import { ReactNode } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import PauseCircleOutlineIcon from "@mui/icons-material/PauseCircleOutline";
import { isString } from "lodash";
import { makeSxStyles } from "ui";

export interface InteractableCellProps {
  onDelete?: () => void;
  onLink?: () => void;
  onEdit?: () => void;
  onSend?: () => void;
  onSendDisabled?: boolean;
  label: string | ReactNode;
  onPause?: () => void;
  isPaused?: boolean;
}

const InteractableCell = ({
  label,
  onEdit,
  onLink,
  onDelete,
  onSend,
  onPause,
  isPaused,
  onSendDisabled,
}: InteractableCellProps) => {
  const styles = useStyles();
  const isInteractable = !!onEdit || !!onDelete;
  return (
    <Box sx={styles.section}>
      <Box>
        {isString(label) && <Typography variant="caption">{label}</Typography>}
        {!isString(label) && label}
      </Box>
      {isInteractable && (
        <Box sx={styles.buttons} className="toShow ">
          {!!onPause && (
            <IconButton size="small" onClick={onPause}>
              {isPaused ? (
                <PlayCircleOutlineIcon fontSize="small" />
              ) : (
                <PauseCircleOutlineIcon fontSize="small" />
              )}
            </IconButton>
          )}
          {!!onSend && (
            <IconButton disabled={onSendDisabled} size="small" onClick={onSend}>
              <SendIcon fontSize="small" />
            </IconButton>
          )}
          {!!onLink && (
            <IconButton size="small" onClick={onLink}>
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          )}
          {!!onEdit && (
            <IconButton size="small" onClick={onEdit} data-testid="edit-button">
              <EditIcon fontSize="small" />
            </IconButton>
          )}
          {!!onDelete && (
            <IconButton
              size="small"
              onClick={onDelete}
              data-testid="delete-button"
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  section: {
    position: "relative",
  },
  buttons: {
    position: "absolute",
    right: "0",
    top: "0",
    bottom: "0",
    ".MuiIconButton-root": {
      backgroundColor: "transparent !important",
    },
  },
}));

export default InteractableCell;
